import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY } from '@constant/colors';

const Search = ({ className, color }) => (
  <svg className={className} viewBox="19 18 14 14">
    <path
      d="M28.198 23.62c0-.984-.35-1.826-1.05-2.526-.7-.7-1.542-1.05-2.527-1.05-.984 0-1.826.35-2.526 1.05-.7.7-1.05 1.542-1.05 2.527 0 .986.35 1.828 1.05 2.528.7.7 1.542 1.05 2.527 1.05.986 0 1.828-.35 2.528-1.05.7-.7 1.05-1.542 1.05-2.527zm4.088 6.644c0 .277-.1.516-.304.718-.202.203-.44.304-.718.304-.288 0-.527-.1-.72-.304l-2.737-2.73c-.953.66-2.015.99-3.186.99-.76 0-1.488-.148-2.183-.443-.694-.297-1.293-.696-1.796-1.2-.502-.502-.9-1.1-1.197-1.795-.295-.695-.443-1.423-.443-2.184 0-.76.148-1.488.443-2.183.296-.694.695-1.293 1.198-1.796.504-.502 1.103-.9 1.797-1.197.695-.295 1.423-.443 2.184-.443.762 0 1.49.148 2.185.443.694.296 1.293.695 1.796 1.198.504.504.903 1.103 1.2 1.797.294.695.442 1.423.442 2.184 0 1.172-.33 2.234-.99 3.187l2.738 2.738c.197.197.296.437.296.72z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

Search.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Search.defaultProps = {
  color: OSLO_GRAY,
};

export default Search;
